import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-the-universal-process-clarify',
	templateUrl: './cig-the-universal-process-clarify.component.html',
	styleUrls: ['./cig-the-universal-process-clarify.component.scss']
})
export class CigTheUniversalProcessClarifyComponent implements OnInit {

	@Input() slides;
	@Input() foursightassets;
	@Input() author;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
